import { configureStore } from "@reduxjs/toolkit";
import { API } from "./services/API";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import classesReducer from "features/Classes";
import studentsReducer from "features/Students";
import teachersReducer from "features/Teachers";
import reportsReducer from "features/Reports";
import uiReducer from "features/ui";

export const store = configureStore({
  reducer: {
    [API.reducerPath]: API.reducer,
    classes: classesReducer,
    students: studentsReducer,
    teachers: teachersReducer,
    reports: reportsReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(API.middleware),
  devTools: process.env.NODE_ENV !== "production",
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
